import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { Link, useHistory, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import Favorite from "@material-ui/icons/Favorite";
import LocationOn from "@material-ui/icons/LocationOn";
import { CloseOutlined, DeleteOutlineOutlined } from "@material-ui/icons";
import ReactPlayer from "react-player";
import EditIcon from "@material-ui/icons/Edit";

// core components
import Header from "components/MaterialKit/Header/Header.js";
import Footer from "components/MaterialKit/Footer/Footer.js";
import Button from "components/MaterialKit/CustomButtons/Button.js";
import GridContainer from "components/MaterialKit/Grid/GridContainer.js";
import GridItem from "components/MaterialKit/Grid/GridItem.js";
import HeaderLinks from "components/MaterialKit/Header/HeaderLinks.js";
import NavPills from "components/MaterialKit/NavPills/NavPills.js";
import Parallax from "components/MaterialKit/Parallax/Parallax.js";
import SportsEsportsIcon from "@material-ui/icons/SportsEsports";
import BarChartIcon from "@material-ui/icons/BarChart";
import UpdateIcon from "@material-ui/icons/Update";
import AddIcon from "@material-ui/icons/Add";
import profile from "assets/img/faces/christian.jpg";
import Carousel from "react-slick";
import studio1 from "assets/img/examples/studio-1.jpg";
import studio2 from "assets/img/examples/studio-2.jpg";
import studio3 from "assets/img/examples/studio-3.jpg";
import studio4 from "assets/img/examples/studio-4.jpg";
import studio5 from "assets/img/examples/studio-5.jpg";
import work1 from "assets/img/examples/olu-eletu.jpg";
import work2 from "assets/img/examples/clem-onojeghuo.jpg";
import work3 from "assets/img/examples/cynthia-del-rio.jpg";
import work4 from "assets/img/examples/mariya-georgieva.jpg";
import work5 from "assets/img/examples/clem-onojegaw.jpg";

import styles from "assets/jss/material-kit-react/views/profilePage.js";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import Card from "components/MaterialKit/Card/Card";
import CardHeader from "components/MaterialKit/Card/CardHeader";
import CardBody from "components/MaterialKit/Card/CardBody";
import CardFooter from "components/MaterialKit/Card/CardFooter";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import {
  Hidden,
  List,
  ListItem,
  ListItemText,
  Typography,
  ListItemAvatar,
  ListItemSecondaryAction,
  Chip,
  Avatar,
  TextField,
  FormControl,
  InputAdornment,
  Fab,
  Modal,
  Tooltip,
} from "@material-ui/core";
import { getGamer } from "slices/gamerSlice";
import { USER_POSTS } from "constants/routes";
// import ShareCoins from './Coins/ShareCoins/ShareCoins';
import { followUser, unfollowUser } from "slices/gamerSlice";
import { DASHBOARD } from "constants/routes";
import { getPostBySlug } from "slices/postSlice";
import image1 from "assets/img/bg.jpg";
import image2 from "assets/img/bg2.jpg";
import image3 from "assets/img/bg3.jpg";

import "assets/scss/plugins/_plugin-react-slick.scss";
import { likePost, unlikePost } from "slices/postSlice";
import { deleteComment } from "slices/postSlice";
import EnhancedCommentForm from "./Comment/EnhancedCommentForm";
import PostActions from "./PostActions/PostActions";
import StarOutlineIcon from "@material-ui/icons/StarBorderOutlined";
import { deletePost } from "slices/postSlice";
import { MY_POSTS } from "constants/routes";

const useStyles = makeStyles(styles);

export default function Post(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { slug } = params;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const {
    post: {
      post,
      loading,
      likedPost,
      unlikedPost,
      likeLoading,
      addedComment,
      deletedComment,
      ratedPost,
      addedPost,
    },
    user,
    gamer: { allGamers },
  } = useSelector((state) => {
    return {
      post: state.post,
      user: state.auth.user,
      gamer: state.gamer,
    };
  }, shallowEqual);

  useEffect(() => {
    dispatch(getPostBySlug(slug));
  }, []);

  useEffect(() => {
    dispatch(getPostBySlug(slug));
  }, [
    slug,
    addedComment,
    deletedComment,
    ratedPost,
    likedPost,
    unlikedPost,
    addedPost,
  ]);

  const handleLikeRequest = (post) => {
    if (
      post.likes.find((like) => like.user.toString() === user._id.toString())
    ) {
      dispatch(unlikePost(post));
    } else {
      dispatch(likePost(post));
    }
  };
  const handleDelete = (post, comment) => {
    dispatch(deleteComment(comment, post._id));
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  if (post === null || loading || post.post === undefined) return <Loader />;

  return (
    <div>
      <Parallax
        // small
        filter
        image={require("assets/img/main/game_background.jpg")}
      >
        <div className={classes.container}>
          <div
            style={{
              display: "flex",
              paddingBottom: "1rem",
              justifyContent: width > 600 ? "flex-end" : "center",
            }}
          >
            <Tooltip
              id="tooltip-left"
              title="Rate or Report Post"
              placement={width > 600 ? "left" : "top"}
            >
              <Fab
                variant="extended"
                style={{
                  color: "#fff",
                  background: "linear-gradient(60deg, #ffa726, #fb8c00)",
                }}
                aria-label="add"
                onClick={() => setOpenModal(true)}
              >
                Rate/Report Post
              </Fab>
            </Tooltip>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={12}>
              <Hidden mdDown implementation="css">
                <Typography
                  variant="h1"
                  style={{ fontSize: "8rem" }}
                  className={classes.typography}
                >
                  {post.post.title.toUpperCase()}
                </Typography>
              </Hidden>
              <Hidden mdUp implementation="css">
                <Typography
                  variant="h1"
                  style={{ fontSize: "3rem" }}
                  className={classes.typography}
                >
                  {post.post.title.toUpperCase()}
                </Typography>
              </Hidden>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.profile}>
                    <div className={classes.name}>
                      <h3 className={classes.title}>
                        {post.post.title.toUpperCase()}{" "}
                        {post.user._id.toString() === user._id.toString() && (
                          <>
                            {width > 600 ? "" : <br />}{" "}
                            <Tooltip
                              id="tooltip-left"
                              title="Edit Post"
                              placement={width > 600 ? "left" : "top"}
                            >
                              <Link
                                to={`/dashboard/posts/${post.post.slug}/edit`}
                              >
                                <Button
                                  color={"danger"}
                                  justIcon
                                  simple
                                  link
                                  // style={{ marginTop: '1rem' }}
                                  className={classes.margin5}
                                >
                                  <EditIcon />
                                </Button>
                              </Link>
                            </Tooltip>
                            <Tooltip
                              id="tooltip-left"
                              title="Delete Post"
                              placement={width > 600 ? "left" : "top"}
                            >
                              <Button
                                color={"danger"}
                                justIcon
                                simple
                                link
                                // style={{ marginTop: '1rem' }}
                                className={classes.margin5}
                                onClick={() => {
                                  dispatch(deletePost(post.post._id));
                                  history.push(MY_POSTS);
                                }}
                              >
                                <DeleteOutlineOutlined />
                              </Button>
                            </Tooltip>
                          </>
                        )}
                      </h3>
                      <br />
                      <div className={classes.title}>
                        Post By:
                        <br />
                        <div
                          style={{
                            display: "inline-flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Link
                            to={`/dashboard/profile/${post.user.username}`}
                            style={{
                              textDecoration: "none",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className={classes.title}
                          >
                            <Avatar
                              imgProps={{
                                style: {
                                  marginTop: "2.5rem",
                                },
                              }}
                              alt={post.user.username}
                              src={post.user.photo}
                              style={{ marginRight: "1rem" }}
                            />{" "}
                            <span className={classes.text}>
                              {" "}
                              {post.user.name.toUpperCase()}
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          flexDirection: width > 600 ? "row" : "column",
                        }}
                      >
                        {post.post.tags &&
                          post.post.tags.length > 0 &&
                          post.post.tags.map((tag, i) => {
                            console.log(tag);
                            return (
                              <Chip
                                avatar={
                                  <Avatar>
                                    {tag.split("")[0].toUpperCase()}
                                  </Avatar>
                                }
                                label={<span>{tag.toUpperCase()}</span>}
                                style={{ margin: "1rem" }}
                                color="secondary"
                                variant="outlined"
                              />
                            );
                          })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <h6 style={{ padding: 0 }} className={classes.title}>
                          {new Date(post.post.createdAt).toDateString()}
                        </h6>
                        <Button
                          color={"warning"}
                          justIcon
                          simple
                          link
                          style={{ marginTop: "1rem" }}
                          className={classes.margin5}
                          onClick={() => setOpenModal(true)}
                        >
                          <StarOutlineIcon /> {post.post.averageRating}
                        </Button>
                        <Button
                          loading={likeLoading}
                          color={
                            post.post.likes.find(
                              (like) =>
                                like.user.toString() === user._id.toString()
                            )
                              ? "rose"
                              : ""
                          }
                          justIcon
                          simple
                          style={{ marginTop: "1rem" }}
                          link
                          onClick={() => handleLikeRequest(post.post)}
                          className={classes.margin5}
                        >
                          <FavoriteBorderIcon /> {post.post.likes.length}
                        </Button>
                      </div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <div className={classes.description}>
                <p>{post.post.description}</p>
              </div>
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.container}>
              <GridContainer justify="center">
                {post.post.photo.length > 0 && (
                  <GridItem xs={12} sm={12} md={6}>
                    <Card>
                      <CardHeader color="danger">
                        {" "}
                        <h3>Pictures</h3>
                      </CardHeader>
                      {/* <h3></h3> */}
                      <CardBody>
                        <Carousel {...settings}>
                          {post.post.photo.map((picture, i) => {
                            return (
                              <div>
                                <img
                                  src={picture}
                                  alt={`${i + 1} slide`}
                                  className="slick-image"
                                />
                                {/* <div className='slick-caption'>
                              <h4>
                                <LocationOn className='slick-icons' />
                                Yellowstone National Park, United States
                              </h4>
                            </div> */}
                              </div>
                            );
                          })}
                        </Carousel>
                      </CardBody>
                    </Card>
                  </GridItem>
                )}
                {post.post.video && (
                  <GridItem xs={12} sm={12} md={6}>
                    <div>
                      <Card>
                        <CardHeader color="danger">
                          <h3>Video</h3>
                        </CardHeader>
                        <CardBody>
                          <div className={classes.playerWrapper}>
                            <ReactPlayer
                              controls={true}
                              url={post.post.video}
                              className={classes.reactPlayer}
                              playing
                              width="100%"
                              height="100%"
                            />
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </GridItem>
                )}
              </GridContainer>
            </div>
          </div>
          <div className={classes.section}>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <Card>
                    <CardHeader color="black">
                      {" "}
                      <h3>Comments</h3>
                    </CardHeader>

                    <CardBody>
                      <List
                        style={{
                          width: "100%",
                          height: 500,
                          overflow: "scroll",
                          // maxWidth: 360,
                          padding: "1rem",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {post.post.comments.length === 0 && (
                          <ListItem
                            alignItems="center"
                            style={{
                              width: "100%",
                              background:
                                "linear-gradient(315deg, #000000 0%, #414141 74%)",
                              color: "#FFFFFF",
                              marginBottom: "1rem",
                              marginTop: "1rem",
                              boxShadow:
                                "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 0, 0, 0.46)",
                              borderRadius: "12px",
                            }}
                          >
                            <ListItemText
                              primary={
                                <span style={{ color: "white" }}>
                                  No comments....
                                </span>
                              }
                            />
                          </ListItem>
                        )}
                        {post.post.comments
                          .map((comment) => {
                            return (
                              <ListItem
                                key={comment._id}
                                alignItems="flex-start"
                                style={{
                                  width: "100%",
                                  background:
                                    "linear-gradient(315deg, #000000 0%, #414141 74%)",
                                  color: "#FFFFFF",
                                  marginBottom: "1rem",
                                  marginTop: "1rem",
                                  boxShadow:
                                    "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 0, 0, 0.46)",
                                  borderRadius: "12px",
                                }}
                              >
                                <ListItemAvatar>
                                  <Avatar
                                    alt={comment.user.username}
                                    src={comment.user.photo}
                                  />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={
                                    <span
                                      style={{
                                        color: "white",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {comment.text}
                                    </span>
                                  }
                                  secondary={
                                    <React.Fragment>
                                      <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inline}
                                        style={{
                                          color: "white",
                                          _hover: {
                                            textDecoration: "underline",
                                          },
                                        }}
                                      >
                                        {comment.user.name}
                                      </Typography>
                                    </React.Fragment>
                                  }
                                />
                                <ListItemSecondaryAction
                                  style={{ justifyContent: "flex-end" }}
                                >
                                  {(comment.user._id.toString() ===
                                    user._id.toString() ||
                                    post.user._id.toString() ===
                                      user._id.toString()) && (
                                    <Button
                                      simple
                                      justIcon
                                      onClick={() =>
                                        handleDelete(post.post, comment)
                                      }
                                    >
                                      <CloseOutlined />
                                    </Button>
                                  )}
                                </ListItemSecondaryAction>
                              </ListItem>
                            );
                          })
                          .sort()}

                        <br />
                      </List>
                      <EnhancedCommentForm />
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{ border: "none" }}
        disableAutoFocus={true}
      >
        <div style={{ marginTop: "5rem", outline: "none" }}>
          <PostActions setOpenModal={setOpenModal} />
        </div>
      </Modal>
    </div>
  );
}
